import "./login.scss";
import axios from "axios";
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: undefined,
    password: undefined,
  });
 
  const axiosInstance = axios.create({baseURL: process.env.REACT_APP_API_URL, withCredentials: true})

  const { loading, error, dispatch } = useContext(AuthContext);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_START" });
    try {
      const res = await axiosInstance.post("/auth/login", credentials);
      if (res.data) {
        dispatch({ type: "LOGIN_SUCCESS", payload: res.data.details });
        navigate("/");
      } else {
        dispatch({
          type: "LOGIN_FAILURE",
          payload: { message: "Something went wrong" },
        });
      }
    } catch (err) {
      dispatch({ type: "LOGIN_FAILURE", payload: err.response.data });
    }
  };

  return (
    <div className="login">
      <div className="lContainer">
        <input
          type="text"
          placeholder="Nazwa użytkownika"
          id="username"
          onChange={handleChange}
          className="lInput"
        />
        <input
          type="password"
          placeholder="Hasło"
          id="password"
          onChange={handleChange}
          className="lInput"
        />
        <button disabled={loading} onClick={handleClick} className="lButton">
          Zaloguj
        </button>
        <div className="registerLink">
          <Link
            to="/register"
            style={{ textDecoration: "none", color: "#999" }}
          >
            <span>Nie masz konta? Zarejestruj się</span>
          </Link>
        </div>
        {error && <span>{error.message}</span>}
        <div className="registerLink">
          <Link
            to="/forget"
            style={{ textDecoration: "none", color: "#999" }}
          >
            <span>Zapomniałeś hasła?</span>
          </Link>
        </div>
        <div className="goBackLink">
          <Link
            to="/"
            style={{ textDecoration: "none", color: "#777" }}
          >
            <span>Wróć na stronę główną.</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
